import * as R from "ramda";
import React, { useState } from "react";

import Popover from "@sessionboard/material-ui/Popover";
import { PopoverMenu } from "components/Base";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import DeleteConfirmation from "ui-kit/DeleteConfirmation";

const ACTION_ICON_MAP = {
  review: "preview",
  edit: "edit",
  copy: "content_copy",
  send: "send",
  open: "start",
  close: "stop_circle",
  export: "file_download",
  duplicate: "content_copy",
  delete: "delete_outline",
  notify: "send",
  unlock: "lock_open",
  lock: "lock",
  share: "ios_share",
  info: "info"
};

const Item = ({ onOptionClick, optionId, optionName, isMenuButton }) => {
  return (
    <MenuItem
      style={{
        color: "#494949",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "30px",
        height: 30,
        minHeight: "unset"
      }}
      key={optionId}
      onClick={
        onOptionClick
          ? e => {
              onOptionClick(isMenuButton ? e : optionId);
            }
          : undefined
      }
      leftIcon={
        <span
          style={{ fontSize: 14, width: 14, height: 14, margin: 8 }}
          className="material-icons-outlined"
        >
          {ACTION_ICON_MAP[optionName.toLowerCase()] ||
            ACTION_ICON_MAP[optionId]}
        </span>
      }
    >
      <span style={{ marginLeft: -30 }}>{optionName}</span>
    </MenuItem>
  );
};

const DotMenu = ({ item, handleAction }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = anchorEl ? "dot-menu" : undefined;

  return (
    <>
      <div
        style={{
          fontSize: "14px",
          cursor: "pointer",
          padding: "3px 5px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center"
        }}
        onClick={handleClick}
      >
        <i
          className="material-icons"
          style={{
            fontSize: "14px"
          }}
        >
          more_horiz
        </i>
      </div>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <Menu>
          {R.map(
            o => {
              switch (o.id) {
                case "delete" && o.showConfirmation !== false:
                  return (
                    <DeleteConfirmation
                      text="Are you sure?"
                      confirmLabel="Delete"
                      onConfirm={() => {
                        handleAction(o.id);
                        handleClose();
                      }}
                    >
                      <div>
                        <Item optionName={o.name} optionId={o.id} />
                      </div>
                    </DeleteConfirmation>
                  );
                case "menu":
                  return (
                    <PopoverMenu
                      wrapperProps={{ style: { display: "block" } }}
                      Label={({ onClick }) => (
                        <Item
                          onOptionClick={onClick}
                          optionName={o.name}
                          optionId={o.id}
                          isMenuButton
                        />
                      )}
                      menuItems={o.options.map(o => [
                        o.name,
                        () => handleAction(o.id)
                      ])}
                    />
                  );
                default:
                  return (
                    <Item
                      key={o.id}
                      onOptionClick={id => {
                        handleAction(id);
                        handleClose();
                      }}
                      optionId={o.id}
                      optionName={o.name}
                    />
                  );
              }
            }, // We filter here review as per 503 API error
            //    https://lenndapp.atlassian.net/browse/SB-2826
            R.prop("options", item)
          )}
        </Menu>
      </Popover>
    </>
  );
};

export default DotMenu;
